import React, { useState, useEffect } from "react";

import axios from "axios";
import { uri } from "../../../help/Api";

import Grid from "@material-ui/core/Grid";
import ButtonBase from "@material-ui/core/ButtonBase";
import { sto } from "../../../Context/InshData";
import { QRCodeCanvas } from "qrcode.react";

function InvBarcode(props) {
  const { InvForFatora } = props;
  const locDinv = JSON.parse(localStorage.getItem("datainv")) || {};

  const sty = {
    dirL: { direction: "ltr" },
  };
  const locInv = JSON.parse(localStorage.getItem("datainv")) || {};

  return (
    <Grid item container style={sty.dirL}>
      <Grid item xs={12}>
        {(locInv?.Step_inv2 && InvForFatora?.ZatcaQR) ? (
          <ButtonBase style={{ borderRadius: "3", margin: 0, padding: 0, marginTop: 0 }}>
            {
              <QRCodeCanvas value={InvForFatora?.ZatcaQR} />
            }

          </ButtonBase>
        ) :
          (
            <ButtonBase style={{ border: "solid 1px #be151f" }}>
              {
                <img
                  src={`data:image/jpeg;base64,${InvForFatora.qr_image}`}
                  style={{ height: 120, width: 120 }}
                />

              }
            </ButtonBase>
          )}

      </Grid>
    </Grid>
  );
}
export default InvBarcode;
